/**
 * Сворачиваемые блоки карточки задачи: состав, подписи и общее состояние.
 *
 * Карточка из семи блоков не помещается на экран целиком, и до нужного
 * приходится прокручивать всё остальное. Блоки сворачиваются, а что
 * развёрнуто при открытии задачи — выбирает сам пользователь в профиле.
 *
 * Название и описание не сворачиваются: карточка без них не отвечает
 * на вопрос «что это за задача», а ради него её и открывают.
 *
 * Состояние живёт в контексте, а не в каждом разделе: секции ничего
 * не знают друг о друге, а настройка у них общая — протаскивать её
 * пропсами через пять компонентов незачем.
 */

import type { TaskSection } from "@taskflow/contracts";
import { createContext, useContext } from "react";

// Состав и подписи — общие с приложением.
export { TASK_SECTION_LABELS, TASK_SECTIONS } from "@taskflow/client-core/tasks";

export interface TaskSectionCollapse {
  isOpen: (section: TaskSection) => boolean;
  toggle: (section: TaskSection) => void;
}

export const TaskSectionCollapseContext = createContext<TaskSectionCollapse | null>(null);

/** null — секция показана без провайдера и разворачивается целиком. */
export function useTaskSectionCollapse(): TaskSectionCollapse | null {
  return useContext(TaskSectionCollapseContext);
}
